import type { ExcelDownloadClient, ExcelDownloadResult } from "app/components/React/ExcelButton/ExcelClientDownload";
import type {
    LeadsExcelDownloadRequestDto,
    LeadsSearchRequestDto,
    LeadsSearchResponseDto,
} from "app/pages/sales-intelligence/modules/leads-search";
import type { IFetchService, PostConfigObject } from "app/services/fetchService";

import { BASE_ENDPOINT_PATH } from "./const";

/**
 * Service for all "companies"-based endpoints
 */
export const createCompaniesApiService = (fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) => {
    const baseCompaniesPath = `${BASE_ENDPOINT_PATH}/companies`;

    return {
        fetchSearchResults(dto: LeadsSearchRequestDto, config?: PostConfigObject): Promise<LeadsSearchResponseDto> {
            return fetchService.post(baseCompaniesPath, dto, config);
        },

        exportToExcel(dto: LeadsExcelDownloadRequestDto): Promise<ExcelDownloadResult> {
            return excelDownloadClient(`${baseCompaniesPath}/excel`, dto);
        },
    };
};
